// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import { makeApiCall, makeFormApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/************************ GET SEARCH MEMBER LOAN LIST START ****************** */
export const fetchSearchMemberLoanList = (listData: any) => {
	const data = {
		SearchMemberLoanListDataToken: listData,
	};
	const url = `${API_URL}getSearchForMemberLoanListDetails`;
	return makeApiCall(url, data);
};
/************************ GET SEARCH MEMBER LOAN LIST END ****************** */

/************************ GET SEARCH MEMBER LOAN INFO START ****************** */
export const fetchMemberLoanInfo = (listData: any) => {
	const data = {
		LoanInfoBasedOnMemeberLoanDataToken: listData,
	};
	const url = `${API_URL}getLoanInfoBasedOnMemeberLoanIndexDetails`;
	return makeApiCall(url, data);
};
/************************ GET SEARCH MEMBER LOAN INFO END ****************** */

/************************ UPDATE INTEREST WAIVER START****************** */
export const memberCollectionUpdateAPI = (listData: any) => {
	const data = {
		UpdateMemberListData: listData,
	};
	const url = `${API_URL}updateMemberLoanPaidForSelectedMembers`;
	return makeApiCall(url, data);
};
/************************ UPDATE INTEREST WAIVER END ****************** */

/************************ MEMBER DEATH UPDATE START ****************** */
export const memberDeathUpdateAPI = (listData: any) => {
	const data = {
		UpdateMemberDeathData: listData,
	};
	const url = `${API_URL}updateMemberDeathDetails`;
	return makeApiCall(url, data);
};
/************************ MEMBER DEATH UPDATE END ****************** */

/************************  INTEREST WAIVER UPDATE START ****************** */
export const interestWaiverUpdateAPI = (listData: any) => {
	const data = {
		UpdateInterestWaiverData: listData,
	};
	const url = `${API_URL}updateInterestWaiverDetails`;
	return makeApiCall(url, data);
};
/************************  INTEREST WAIVER UPDATE END ****************** */

/************************ GET MEMBER LOAN PAID START ****************** */
export const memberCollectionFetchAPI = (listData: any) => {
	const data = {
		FetchMemberCollectionData: listData,
	};
	const url = `${API_URL}fetchMemberLoanPaidForSelectedMembersDetails`;
	return makeApiCall(url, data);
};
/************************ GET MEMBER LOAN PAID END ****************** */

/************************ GET MEMBER WALLET START ****************** */
export const memberWalletFetchAPI = (listData: any) => {
	const data = {
		FetchMemberWalletData: listData,
	};
	const url = `${API_URL}fetchMemberWalletForSelectedMembersDetails`;
	return makeApiCall(url, data);
};
/************************ GET MEMBER WALLET END ****************** */

/************************ GET MEMBER QR START ****************** */
export const memberQrFetchAPI = (listData: any) => {
	const data = {
		FetchMemberQrData: listData,
	};
	const url = `${API_URL}fetchMemberQrForSelectedMembersDetails`;
	return makeApiCall(url, data);
};
/************************ GET MEMBER QR END ****************** */

/************************ GET MEMBER REPAYMENT START ****************** */
export const memberRepaymentFetchAPI = (listData: any) => {
	const data = {
		FetchMemberRepaymentData: listData,
	};
	const url = `${API_URL}fetchMemberRepaymentForSelectedMember`;
	return makeApiCall(url, data);
};
/************************ GET MEMBER REPAYMENT END ****************** */

/************************ REVERT MEMBER COLLECTION START ****************** */
export const memberWalletRevertAPI = (listData: any) => {
	const data = {
		RevertMemberWalletData: listData,
	};
	const url = `${API_URL}revertMemberWalletForSelectedMembersDetails`;
	return makeApiCall(url, data);
};
/************************ REVERT MEMBER COLLECTION END ****************** */

/************************ REVERT MEMBER COLLECTION START ****************** */
export const memberCollectionRevertAPI = (listData: any, serviceName: any) => {
	const data = {
		RevertMemberListData: listData,
	};
	const url = `${API_URL}${serviceName}`;
	return makeApiCall(url, data);
};
/************************ REVERT MEMBER COLLECTION END ****************** */

/************************ MEMBER LOAN CARD PDF START ****************** */
export const getMemberLoanCardPDF = (listData: any) => {
	const queryParams = new URLSearchParams();
	queryParams.append('MemberLoanCardPDFToken', listData);
	const url = `${API_URL}tcpdf/pdf/LoanCardPDF.php`;
	return makeFormApiCall(url, queryParams);
};
/************************ MEMBER LOAN CARD PDF END ****************** */

/************************ MEMBER REPAYMENT PDF START ****************** */
export const getMemberRepaymentPDF = (listData: any) => {
	const queryParams = new URLSearchParams();
	queryParams.append('MemberRepaymentPDFToken', listData);
	const url = `${API_URL}tcpdf/pdf/MemberRepaymentPDF.php`;
	return makeFormApiCall(url, queryParams);
};
/************************ MEMBER REPAYMENT PDF END ****************** */

/************************ MEMBER LOANCARD REPORT START ****************** */
export const geMemberLoanCardReport = (listData: any) => {
	const queryParams = new URLSearchParams();
	queryParams.append('LoanCardReportToken', listData);
	const url = `${API_URL}Excel/LoanCardReportWithToken.php`;
	return makeFormApiCall(url, queryParams);
};
/************************ MEMBER LOAN CARD REPORT END ****************** */

/************************ MEMBER LOAN COLLECTION APPROVAL START ****************** */
export const memberLoanCollectionApprovalAPI = (listData: any) => {
	const data = {
		MemberLoanCollectionApprovalData: listData,
	};
	const url = `${API_URL}memberLoanCollectionApproval`;
	return makeApiCall(url, data);
};
/************************ MEMBER LOAN COLLECTION APPROVAL END ****************** */

/************************ MEMBER LOAN COLLECTION APPROVAL START ****************** */
export const memberWalletAddAPI = (Data: any) => {
	const data = {
		AddAmountToWalletToken: Data,
	};
	const url = `${API_URL}addAmountToWallet`;
	return makeApiCall(url, data);
};
/************************ MEMBER LOAN COLLECTION APPROVAL END ****************** */

/************************ MEMBER LOAN COLLECTION APPROVAL START ****************** */
export const memberLoanPaidEntry = (Data: any) => {
	const data = {
		UpdateLoanPaidToken: Data,
	};
	const url = `${API_URL}updateLoanPaid`;
	return makeApiCall(url, data);
};
/************************ MEMBER LOAN COLLECTION APPROVAL END ****************** */

/************************ MEMBER LOAN COLLECTION APPROVAL START ****************** */
export const memberArrearLoanPaidEntry = (Data: any) => {
	const data = {
		UpdateArrearLoanPaidTokenData: Data,
	};
	const url = `${API_URL}updateArrearLoanPaidDetails`;
	return makeApiCall(url, data);
};
/************************ MEMBER LOAN COLLECTION APPROVAL END ****************** */

/************************ GET THRIFT COLLECTION DETAILS SERVICE ****************** */
export const getThriftCollectionDetailsApi = (Data: any) => {
	const data = {
		GetThriftCollectionDetailsToken: Data,
	};
	const url = `${API_URL}getThriftCollectionDetails`;
	return makeApiCall(url, data);
};
/************************ GET THRIFT COLLECTION DETAILS END ****************** */

/************************ REVERT THRIFT COLLECTION SERVICE ****************** */
export const revertThriftCollectionCall = (Data: any) => {
	const data = {
		RevertThriftCollectionTokenData: Data,
	};
	const url = `${API_URL}revertThriftCollection`;
	return makeApiCall(url, data);
};
/************************ REVERT THRIFT COLLECTION END ****************** */
